// extracted by mini-css-extract-plugin
var _1 = "app";
var _2 = "flex-column";
var _3 = "flex-items-center";
var _4 = "flex-justify-between";
var _5 = "flex-justify-end";
var _6 = "flex-justify-start";
var _7 = "flex-row";
var _8 = "font-black";
var _9 = "font-bold";
var _a = "font-large";
var _b = "font-light";
var _c = "font-medium";
var _d = "font-normal";
var _e = "font-semibold";
var _f = "font-small";
var _10 = "font-xlarge";
var _11 = "font-xsmall";
var _12 = "font-xxlarge";
var _13 = "quiq-floating-element";
var _14 = "quiq-togglechatbutton-button";
var _15 = "slide-pane";
var _16 = "slide-pane_from_right";
var _17 = "slide-pane__overlay";
export { _1 as "app", _2 as "flexColumn", _3 as "flexItemsCenter", _4 as "flexJustifyBetween", _5 as "flexJustifyEnd", _6 as "flexJustifyStart", _7 as "flexRow", _8 as "fontBlack", _9 as "fontBold", _a as "fontLarge", _b as "fontLight", _c as "fontMedium", _d as "fontNormal", _e as "fontSemibold", _f as "fontSmall", _10 as "fontXlarge", _11 as "fontXsmall", _12 as "fontXxlarge", _13 as "quiqFloatingElement", _14 as "quiqTogglechatbuttonButton", _15 as "slidePane", _16 as "slidePaneFromRight", _17 as "slidePaneOverlay" }
